import React from 'react'
import styles from './style.module.css'

interface INotificationsProps {
  children: React.ReactNode
}

const Notifications = ({ children }: INotificationsProps) => {
  return <div className={styles.notificationsBase}>{children}</div>
}

export default Notifications
